import { useEffect, useState } from 'react'

/**
 * The current time in milliseconds, re-read every `intervalMs`. For countdowns and "expired" marks
 * that must change while the page sits open. Without this they are computed once, at render, and a
 * link that expires while someone is looking at it keeps showing as live.
 */
export function useNow(intervalMs: number): number {
    const [now, setNow] = useState(() => Date.now())
    useEffect(() => {
        const id = setInterval(() => setNow(Date.now()), intervalMs)
        return () => clearInterval(id)
    }, [intervalMs])
    return now
}
